import './select.css';

import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Icon as PrimitiveIcon, Trigger } from '@radix-ui/react-select';
import React from 'react';

import { cn } from '@/services/utils';

import { Icon } from '../Icon';

interface SelectTriggerProps extends React.ComponentPropsWithoutRef<typeof Trigger> {
    borderless?: boolean;
}

/**
 * The button that toggles the select.
 * The Select.Content will position itself by aligning over the trigger.
 */
const SelectTrigger = React.forwardRef<
    React.ElementRef<typeof Trigger>,
    SelectTriggerProps
>(({ borderless, className, children, ...props }, ref) => (
    <Trigger
        ref={ref}
        className={cn(
            `select-trigger
                 ${borderless ? 'borderless-select-trigger' : 'bordered-select-trigger'}
                 tw-flex
                 tw-h-9
                 tw-w-full
                 tw-items-center
                 tw-justify-between
                 tw-border-input
                 tw-bg-transparent
                 tw-p-2
                 tw-text-t-sm
                 tw-bg-white
                 disabled:tw-cursor-not-allowed
                 disabled:tw-opacity-50`,
            className,
        )}
        {...props}
    >
        {children}
        <PrimitiveIcon asChild>
            <Icon icon={ChevronDownIcon} variant="dark" size="sm" />
        </PrimitiveIcon>
    </Trigger>
));

SelectTrigger.displayName = Trigger.displayName;

export { SelectTrigger };
